import type { LinksFunction } from '@remix-run/node'
import { useLoaderData, NavLink, Outlet, generatePath } from '@remix-run/react'
import { H4, H5, Hero, Section, Stack } from '~/components-v2'
import { getDemoSessions } from '~/services/contentful'
import demos from './demos.css?url'
import { typedjson } from 'remix-typedjson'
import { editorialDate } from '~/utils/date'
import { DemoSession } from '~/types/demo-session'

export const links: LinksFunction = () => [{ rel: 'stylesheet', href: demos }]

export { meta } from '~/utils'
export { ErrorBoundary } from '~/components/error-boundary'

export const loader = async () => {
  const demoSessions = await getDemoSessions()
  return typedjson({ swiftypeSiteType: 'Demos', demoSessions })
}

export default function () {
  const { demoSessions } = useLoaderData<typeof loader>()
  return (
    <>
      <Hero title="Demos" />
      <div className="banner demo-disclosure">
        <div>
          <strong>Note:</strong> Demos highlight what we are working on or
          experimenting with, but are not a guarantee of release. Let us know
          your thoughts at <a href="mailto:support@omni.co">support@omni.co</a>.
        </div>
      </div>
      <Section aside={<Nav demoSessions={demoSessions} />}>
        <Outlet />
      </Section>
    </>
  )
}

const demoSessionLink = (slug: string) => generatePath(`/demos/:slug`, { slug })

const NavItem = ({ date, slug, isLatest, title }: DemoSession) => {
  return (
    <NavLink end to={isLatest ? '/demos' : demoSessionLink(slug)}>
      <H5 color="text4" fontSize="xxs">
        {editorialDate(date)}
      </H5>
      <H4 color="text" fontSize="xs" lineHeight={1.5}>
        {title}
      </H4>
    </NavLink>
  )
}

const Nav = ({ demoSessions }: { demoSessions: DemoSession[] }) => (
  <Stack as="nav" className="demo-session-nav" gap={4}>
    {demoSessions.map((entry) => (
      <NavItem key={entry.slug} {...entry} />
    ))}
  </Stack>
)
